<template>
  <div id="page-user-list">
    <vs-row class="mb-5" vs-align="center">
      <div class="vx-col w-1/2">
        <h2 class="breadcrumb">Σύνδεσμοι προϊόντων <small style="font-size:12px;">{{ smallTitle }}</small></h2>
      </div>

      <div class="vx-col w-1/2">
        <div class="flex flex-wrap" style="justify-content: end !important;">
          <vs-button @click="importProductsFromXLS" color="primary" type="border" icon="cloud" class="mb-2">
            Εισαγωγή συνδέσμων
          </vs-button>
        </div>
      </div>
    </vs-row>
    <div class="vx-card p-6">

      <div class="flex flex-wrap" style="justify-content: space-between;">
        <vs-input class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4" v-model="searchQuery"
                  @input="updateSearchQuery" placeholder="Αναζήτηση..."/>
<!--        <vs-button @click="importProductsFromXLS" color="dark" type="border" v-if="$route.query.failing === '1'">-->
<!--          Εκτέλεση αναζήτησης-->
<!--        </vs-button>-->
      </div>

      <!-- AgGrid Table -->
      <ag-grid-vue ref="agGridTable" :components="components" :gridOptions="gridOptions"
                   class="ag-theme-material w-100 my-4 ag-grid-table" :columnDefs="columnDefs"
                   :defaultColDef="defaultColDef"
                   :rowData="recordsData['products']" rowSelection="multiple"
                   :animateRows="true"
                   :floatingFilter="true" :pagination="true" :cacheBlockSize="10"
                   :paginationPageSize="paginationPageSize"
                   @cell-double-clicked="onCellDoubleClicked"
                   :paginationAutoPageSize="true" :filter="true">
      </ag-grid-vue>
    </div>
  </div>
</template>
<script>
import {AgGridVue} from 'ag-grid-vue'
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import CellRendererLink from './cell-renderer-products/CellRendererLink.vue'
import CellRendererStatus from './cell-renderer-products/CellRendererStatus.vue'
import CellRendererVerified from './cell-renderer-products/CellRendererVerified.vue'
import CellRendererActionsFailing from './cell-renderer-products/CellRendererActionsFailing.vue'
import axios from '@/axios'

export default {
  components: {
    AgGridVue,
    vSelect,
    flatPickr,
    CellRendererLink,
    CellRendererStatus,
    CellRendererVerified,
    CellRendererActionsFailing,
  },
  data() {
    return {
      item: {
        checked: '',
        skroutz: '',
        part_number: '',
        name: '',
        erp_price: '',
        promo_price: '',
        categoryId: null,
      },
      smallTitle: '',
      searchQuery: '',
      gridApi: null,
      gridOptions: {
        floatingFilter: true,
        filter: 'agTextColumnFilter',
        pagination: true,
        animateRows: true,
        resizable: true,
        enableCellSelection: true,
        rowSelection: 'multiple',
      },
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true,
      },
      columnDefs: [
        {
          headerName: 'UID',
          field: 'product.id',
          width: 125,
          filter: 'agTextColumnFilter',
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: true,
          hide: false
        },
        {
          headerName: 'Προϊόν',
          field: 'product.name',
          filter: 'agTextColumnFilter',
          width: 160,
        },
        {
          headerName: 'Κατηγορία',
          field: 'product.category.name',
          filter: 'agTextColumnFilter',
          width: 150,
        },
        {
          headerName: 'Μάρκα',
          field: 'product.manufacturer',
          filter: 'agTextColumnFilter',
          width: 150,
        },
        {
          headerName: 'MPN',
          field: 'product.part_number',
          filter: 'agTextColumnFilter',
          width: 150,
        },
        {
          headerName: 'Πηγή',
          field: 'eshop.name',
          filter: 'agTextColumnFilter',
          width: 150,
          cellStyle: {'text-align': 'right'},
        },
        {
          headerName: 'URL',
          field: 'eshopURL',
          filter: 'agTextColumnFilter',
          flex: 1,
          minWidth: 150,
        }
      ],
      components: {
        CellRendererLink,
        CellRendererStatus,
        CellRendererVerified,
        CellRendererActionsFailing,
      },
    }
  },
  watch: {
    roleFilter(obj) {
      this.setColumnFilter('role', obj.value)
    },
    statusFilter(obj) {
      this.setColumnFilter('status', obj.value)
    },
    isVerifiedFilter(obj) {
      const val =
          obj.value === 'all' ? 'all' : obj.value === 'yes' ? 'true' : 'false'
      this.setColumnFilter('is_verified', val)
    },
    departmentFilter(obj) {
      this.setColumnFilter('department', obj.value)
    },
  },
  computed: {
    recordsData() {
      return this.$store.getters.getProductsUrls
    },
    paginationPageSize() {
      if (this.gridApi) return this.gridApi.paginationGetPageSize()
      else return 10
    },
    totalPages() {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages()
      else return 0
    },
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
        else return 1
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1)
      },
    },
    message: {
      get() {
        return this.$store.state.obj.message
      },
      set(value) {
        this.$store.commit('updateMessage', value)
      },
    },
  },
  methods: {
    onCellDoubleClicked(params) {
      window.open('/products/edit/' + params.data.product.id, '_blank');
    },
    importProductsFromXLS() {
      this.$vs.dialog({
        type: 'confirm',
        color: 'warning',
        title: `Επιβεβαίωση`,
        text: 'Θα μεταφερθείτε σε περιβάλλον εισαγωγή νέων συνδέσμων από excel. Είστε σίγουροι;',
        acceptText: 'Άνοιγμα',
        cancelText: 'Ακύρωση',
        accept: this.importProductsnLinksAction
      })
    },
    importProductsnLinksAction() {
      window.location.href = "/settings/sync-xls";
    },
    setColumnFilter(column, val) {
      const filter = this.gridApi.getFilterInstance(column)
      let modelObj = null

      if (val !== 'all') {
        modelObj = {type: 'equals', filter: val}
      }

      filter.setModel(modelObj)
      this.gridApi.onFilterChanged()
    },
    resetColFilters() {
      // Reset Grid Filter
      this.gridApi.setFilterModel(null)
      this.gridApi.onFilterChanged()

      // Reset Filter Options
      this.roleFilter =
          this.statusFilter =
              this.isVerifiedFilter =
                  this.departmentFilter =
                      {
                        label: 'All',
                        value: 'all',
                      }

      this.$refs.filterCard.removeRefreshAnimation()
    },
    updateSearchQuery(val) {
      this.gridApi.setQuickFilter(val)
    },
  },
  mounted() {
    this.gridApi = this.gridOptions.api
  },
  created() {
    this.$vs.loading()
    let parameters = this.$route.query
    if (parameters.enabled === "1") {
      this.smallTitle = '(Ενεργά urls)'
      this.$store.dispatch('fetchProductsUrlsStatus', parameters.enabled).then(() => {
        this.$vs.loading.close()
      })
    } else if (parameters.enabled === "0") {
      this.smallTitle = '(Μη ενεργά urls)'
      this.$store.dispatch('fetchProductsUrlsStatus', parameters.enabled).then(() => {
        this.$vs.loading.close()
      })
    } else if (parameters.failing === "1") {
      this.smallTitle = '(Προβληματικά urls)'
      this.columnDefs.push({
        headerName: '',
        field: 'id',
        width: 120,
        cellRendererFramework: 'CellRendererActionsFailing',
        pinned: 'right',
        suppressNavigable: true,
        cellClass: 'no-border',
        filter: false,
      })


      this.$store.dispatch('fetchProductsUrlsFailed').then(() => {
        this.$vs.loading.close()
      })
    } else {
      this.$store.dispatch('fetchProductsUrls').then(() => {
        this.$vs.loading.close()
      })
    }
    this.$vs.loading.close()
  },
}
</script>
<style lang="scss">
#page-user-list {
  .user-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}
</style>
